<template>
  <default-layout>
    <section slot="content">

      <v-container fluid>

        <!-- =========================================================
             FILTROS
        ========================================================== -->

        <v-row class="mt-2">

          <v-col cols="12">

            <v-row>

              <!-- GROUP -->

              <v-col
                cols="12"
                md="6"
              >

                <v-select
                  v-model="groupSelected"
                  :items="select.groups"
                  item-value="id"
                  item-text="name"
                  label="Group"
                  dense
                  outlined
                ></v-select>

              </v-col>


              <!-- ORDER -->

              <v-col
                cols="12"
                md="6"
              >

                <v-select
                  v-model="orderBy"
                  :items="select.filters"
                  item-value="id"
                  item-text="name"
                  label="Ordenar por:"
                  dense
                  outlined
                  @change="findProduct"
                ></v-select>

              </v-col>

            </v-row>


            <!-- DISPLAY DISCOUNT -->

            <v-row
              align="center"
              justify="center"
            >

              <v-col
                cols="12"
                md="6"
              >
                <v-checkbox
                  label="¿Desea visualizar el % de descuento en las imágenes generadas?"
                  v-model="displayProductOff"
                  dense
                  hide-details
                  class="mt-0 mb-0"
                ></v-checkbox>
              </v-col>
            </v-row>
            <v-row
              align="center"
              justify="center"
            >
              <v-col
                cols="12"
                md="6"
              >
                <v-checkbox
                  label="¿Desea activar la seleccion para estados de whatsapp?"
                  v-model="displayChecksForWhatsapp"
                  dense
                  hide-details
                  class="mt-0 mb-0"
                ></v-checkbox>
              </v-col>
            </v-row>

          </v-col>

        </v-row>


        <!-- =========================================================
             PRODUCTOS
        ========================================================== -->

        <v-row justify="center">

          <v-col cols="12" lg="8" md="12" xs="12">

            <v-row>

              <template
                v-for="(item, index) in shownCards"
              >

                <v-col
                  :ref="item.id"
                  :key="item.id"
                  cols="12"
                  lg="3"
                  md="4"
                  sm="6"
                  xs="12"
                >

                  <!-- =================================================
                       PRODUCT CARD
                  ================================================== -->

                  <v-card
                    style="border: 5px solid #1b74e4"
                    outlined
                    elevation="0"
                  >

                    <!-- CHECKBOX ESTADO WHATSAPP -->

                    <v-card-title class="pa-2" v-if="displayChecksForWhatsapp">

                      <v-checkbox
                        v-model="selectedWhatsappIds"
                        :value="item.id"
                        hide-details
                        class="ma-0 pa-0"
                        color="green"
                      >

                        <template v-slot:label>

                          <span class="whatsapp-checkbox-label">

                            <v-icon
                              color="green"
                              small
                              class="mr-1"
                            >
                              mdi-whatsapp
                            </v-icon>

                            Estado WhatsApp

                          </span>

                        </template>

                      </v-checkbox>

                    </v-card-title>


                    <!-- PRODUCT IMAGE -->

                    <img
                      :min-height="$vuetify.breakpoint.xsOnly ? 250 : 180"
                      style="width: 100%;"
                      :src="item.product_color_image[0].image"
                      :key="item.product_color_image[0].image"
                    >


                    <!-- GROUP -->

                    <v-card-title
                      class="justify-center mt-n2"
                    >

                      <span class="input-group-product">

                        {{ item.product.group }}

                      </span>

                    </v-card-title>


                    <v-card-text>

                      <!-- RATING -->

                      <v-row
                        align="center"
                        class="mx-0"
                      >

                        <v-rating
                          :value="
                            item.product.average_star
                              ? item.product.average_star
                              : 5
                          "
                          color="secondary"
                          dense
                          half-increments
                          readonly
                          size="16"
                        ></v-rating>

                      </v-row>


                      <!-- NAME -->

                      <div class="my-3 product-name">

                        <span
                          class="input-name-product"
                          @click="productImageSelected(item)"
                        >

                          {{ item.product.name }}

                        </span>

                      </div>

                    </v-card-text>


                    <!-- PRICE -->

                    <v-card-title class="mt-n10">

                      <v-row no-gutters>

                        <!-- WITH DISCOUNT -->

                        <template v-if="item.product.off">

                          <v-col
                            cols="3"
                            sm="4"
                            xs="4"
                          >

                            <v-card
                              class="pa-0 ma-0 text-left"
                              style="border: 0"
                              outlined
                              elevation="0"
                            >

                              <img
                                :src="require('@/assets/logo.png')"
                                alt="Dino Toys"
                                width="45"
                              >

                            </v-card>

                          </v-col>


                          <v-col
                            cols="9"
                            sm="8"
                            xs="8"
                          >

                            <v-card
                              class="pa-0 ma-0 text-right conetnido"
                              style="border: 0"
                              outlined
                              elevation="0"
                            >

                              <v-chip
                                v-if="displayProductOff"
                                color="pink"
                                label
                                text-color="white"
                              >

                                - {{ item.product.off }}%

                              </v-chip>

                              S/
                              {{ item.product.sale_price }}

                            </v-card>


                            <v-card
                              class="pa-0 ma-0 body-2 text-right"
                              style="border: 0"
                              outlined
                              elevation="0"
                            >

                              S/
                              {{ item.product.regular_price }}

                            </v-card>

                          </v-col>

                        </template>


                        <!-- WITHOUT DISCOUNT -->

                        <template v-else>

                          <v-col
                            cols="6"
                            sm="4"
                            xs="4"
                          >

                            <v-card
                              class="pa-0 ma-0 text-left"
                              style="border: 0"
                              outlined
                              elevation="0"
                            >

                              <img
                                :src="require('@/assets/logo.png')"
                                alt="Dino Toys"
                                width="45"
                              >

                            </v-card>

                          </v-col>


                          <v-col
                            cols="6"
                            sm="8"
                            xs="8"
                          >

                            <v-card
                              class="pa-0 ma-0 text-right"
                              style="border: 0"
                              outlined
                              elevation="0"
                            >

                              S/
                              {{ item.product.regular_price }}

                            </v-card>


                            <v-card
                              class="pa-0 ma-0 body-2 text-right"
                              style="border: 0"
                              outlined
                              elevation="0"
                            >

                              &nbsp;

                            </v-card>

                          </v-col>

                        </template>

                      </v-row>

                    </v-card-title>

                  </v-card>

                </v-col>

              </template>

            </v-row>


            <!-- PAGINATION -->

            <v-row
              justify="center"
              class="pt-8 pb-8"
            >

              <v-pagination
                v-model="page"
                :length="length"
              ></v-pagination>

            </v-row>


            <!-- =====================================================
                 ACTION BUTTONS
            ====================================================== -->

            <v-row>

              <!-- GENERATE NORMAL IMAGES -->

              <v-col
                cols="12"
                md="6"
              >

                <v-btn
                  :disabled="disabledSubmit"
                  color="primary"
                  block
                  depressed
                  @click="generateImages()"
                >

                  <v-icon left>
                    mdi-image-multiple
                  </v-icon>

                  Generar Imágenes

                </v-btn>

              </v-col>


              <!-- GENERATE WHATSAPP -->

              <v-col
                cols="12"
                md="6"
              >

                <v-btn
                  color="green"
                  dark
                  block
                  depressed
                  :disabled="selectedWhatsappIds.length === 0"
                  @click="openWhatsappGenerator"
                >

                  <v-icon left>
                    mdi-whatsapp
                  </v-icon>

                  Generar Estados WhatsApp

                  <span class="ml-2">
                    ({{ selectedWhatsappIds.length }})
                  </span>

                </v-btn>

              </v-col>

            </v-row>


            <!-- SELECTION ACTIONS -->

            <v-row class="mt-2 mb-10">

              <v-col
                cols="12"
                md="6"
              >

                <v-btn
                  outlined
                  color="green"
                  block
                  @click="selectAllWhatsapp"
                >

                  <v-icon left>
                    mdi-checkbox-multiple-marked
                  </v-icon>

                  Seleccionar todos

                </v-btn>

              </v-col>


              <v-col
                cols="12"
                md="6"
              >

                <v-btn
                  outlined
                  color="grey"
                  block
                  @click="clearWhatsappSelection"
                >

                  <v-icon left>
                    mdi-checkbox-multiple-blank
                  </v-icon>

                  Limpiar selección

                </v-btn>

              </v-col>

            </v-row>

          </v-col>

        </v-row>

      </v-container>


      <!-- =========================================================
           SNACKBAR
      ========================================================== -->

      <div class="text-center ma-2">

        <v-snackbar
          timeout="7000"
          v-model="snackbar"
          :color="color"
          top
          z-index="500"
        >

          {{ text }}

          <template v-slot:action="{ attrs }">

            <v-btn
              color="white"
              text
              v-bind="attrs"
              @click="snackbar = false"
            >

              X

            </v-btn>

          </template>

        </v-snackbar>

      </div>


      <!-- =========================================================
           OVERLAY
      ========================================================== -->

      <div class="text-center">

        <v-overlay
          :value="overlay"
          z-index="500"
        >

          <v-progress-circular
            indeterminate
            size="70"
            width="7"
            color="primary"
          ></v-progress-circular>

          <div class="mt-4 white--text">
            {{ overlayText }}
          </div>

        </v-overlay>

      </div>


      <!-- =========================================================
           WHATSAPP GENERATOR
      ========================================================== -->

      <v-dialog
        v-model="showWhatsappGenerator"
        max-width="1200"
        scrollable
        persistent
      >

        <v-card class="generator-dialog">

          <!-- =====================================================
               TOOLBAR
          ====================================================== -->

          <v-toolbar
            dark
            flat
            class="generator-toolbar"
          >

            <v-icon
              left
              large
            >
              mdi-whatsapp
            </v-icon>

            <v-toolbar-title>
              Generador de Estados WhatsApp
            </v-toolbar-title>

            <v-spacer></v-spacer>

            <v-chip
              color="white"
              text-color="green"
              class="mr-3"
            >

              {{ selectedWhatsappProducts.length }}

              productos

            </v-chip>

            <v-btn
              icon
              @click="showWhatsappGenerator = false"
            >

              <v-icon>
                mdi-close
              </v-icon>

            </v-btn>

          </v-toolbar>


          <!-- =====================================================
               CONTENT
          ====================================================== -->

          <v-card-text class="generator-content pa-5">

            <v-row>

              <!-- =================================================
                   SETTINGS
              ================================================== -->

              <v-col
                cols="12"
                md="4"
              >

                <div class="generator-section-title">
                  Configuración
                </div>


                <!-- TIPO DE ESTADO -->

                <div class="configuration-label">
                  Tipo de Estado
                </div>

                <v-select
                  v-model="whatsappTemplate"
                  :items="whatsappTemplates"
                  item-value="id"
                  item-text="name"
                  label="Tipo de estado"
                  outlined
                  dense
                  @change="changeWhatsappTemplate"
                ></v-select>


                <!-- TEMA -->

                <div class="configuration-label mt-2">
                  Tema / Fondo
                </div>

                <v-select
                  v-model="whatsappTheme"
                  :items="whatsappThemes"
                  item-value="id"
                  item-text="name"
                  label="Seleccionar fondo"
                  outlined
                  dense
                  @change="changeWhatsappTheme"
                >

                  <template v-slot:item="data">

                    <v-list-item-content>

                      <v-list-item-title>
                        {{ data.item.name }}
                      </v-list-item-title>

                      <v-list-item-subtitle>
                        {{ data.item.description }}
                      </v-list-item-subtitle>

                    </v-list-item-content>

                  </template>

                </v-select>


                <!-- PREVIEW STYLE -->

                <div
                  class="selected-style-preview"
                  :class="[
                    whatsappTemplateClass,
                    whatsappThemeClass
                  ]"
                >

                  <div class="selected-style-overlay"></div>

                  <div class="selected-style-content">

                    <v-icon
                      color="white"
                      large
                    >
                      mdi-palette
                    </v-icon>

                    <span>
                      {{ currentStyleName }}
                    </span>

                  </div>

                </div>


                <!-- PRODUCT -->

                <v-select
                  v-model="whatsappPreviewProductId"
                  :items="selectedWhatsappProducts"
                  item-value="id"
                  item-text="product.name"
                  label="Producto para vista previa"
                  outlined
                  dense
                  class="mt-4"
                ></v-select>


                <v-divider class="my-4"></v-divider>


                <!-- HEADLINE -->

                <v-text-field
                  v-model="whatsappHeadline"
                  label="Título principal"
                  outlined
                  dense
                ></v-text-field>


                <!-- SUBTITLE -->

                <v-text-field
                  v-model="whatsappSubtitle"
                  label="Subtítulo"
                  outlined
                  dense
                ></v-text-field>


                <!-- FOOTER -->

                <v-text-field
                  v-model="whatsappFooter"
                  label="Texto inferior"
                  outlined
                  dense
                ></v-text-field>


                <v-divider class="my-4"></v-divider>


                <!-- OPTIONS -->

                <v-switch
                  v-model="whatsappShowDiscount"
                  label="Mostrar descuento"
                  color="green"
                  dense
                ></v-switch>

                <v-switch
                  v-model="whatsappShowRegularPrice"
                  label="Mostrar precio anterior"
                  color="green"
                  dense
                ></v-switch>

                <v-switch
                  v-model="whatsappShowLogo"
                  label="Mostrar logo"
                  color="green"
                  dense
                ></v-switch>

                <v-switch
                  v-model="whatsappShowGroup"
                  label="Mostrar categoría"
                  color="green"
                  dense
                ></v-switch>


                <v-divider class="my-4"></v-divider>


                <!-- INFO -->

                <v-alert
                  color="green"
                  text
                  dense
                  border="left"
                >

                  <strong>
                    Formato recomendado
                  </strong>

                  <br>

                  1080 × 1920 px

                  <br>

                  Ideal para Estados de WhatsApp,
                  Instagram Stories y TikTok.

                </v-alert>


                <!-- GENERATE -->

                <v-btn
                  color="green"
                  dark
                  block
                  large
                  depressed
                  :loading="generatingWhatsapp"
                  :disabled="selectedWhatsappProducts.length === 0"
                  @click="generateWhatsappStates"
                >

                  <v-icon left>
                    mdi-download
                  </v-icon>

                  Generar Estados

                </v-btn>

              </v-col>


              <!-- =================================================
                   PREVIEW
              ================================================== -->

              <v-col
                cols="12"
                md="8"
              >

                <div class="generator-section-title">
                  Vista previa
                </div>


                <div class="preview-area">

                  <!-- =================================================
                       WHATSAPP STATUS
                  ================================================== -->

                  <div
                    v-if="whatsappPreviewProduct"
                    id="whatsapp-status-preview"
                    ref="whatsappStatusPreview"
                    class="whatsapp-status"
                    :class="[
                      whatsappTemplateClass,
                      whatsappThemeClass
                    ]"
                  >

                    <!-- =================================================
                         DECORACIONES GENERALES
                    ================================================== -->

                    <div class="status-background-shape shape-one"></div>

                    <div class="status-background-shape shape-two"></div>

                    <div class="status-background-shape shape-three"></div>


                    <!-- =================================================
                         HEADER
                    ================================================== -->

                    <header class="status-header-section">

                      <!-- BADGE -->

                      <div class="status-top-badge">

                        <span v-if="whatsappTemplate === 'offer'">
                          OFERTA
                        </span>

                        <span v-if="whatsappTemplate === 'new'">
                          NUEVO
                        </span>

                        <span v-if="whatsappTemplate === 'category'">
                          COLECCIÓN
                        </span>

                      </div>


                      <!-- HEADLINE -->

                      <div class="status-header">

                        {{ whatsappHeadline }}

                      </div>


                      <!-- SUBTITLE -->

                      <div
                        v-if="
                          whatsappShowGroup &&
                          whatsappPreviewProduct.product.group
                        "
                        class="status-subtitle"
                      >

                        {{ whatsappSubtitle }}

                      </div>


                      <!-- CHILD DECORATIONS -->

                      <div
                        v-if="whatsappTheme === 'child'"
                        class="child-decoration child-star star-one"
                      >
                        ★
                      </div>

                      <div
                        v-if="whatsappTheme === 'child'"
                        class="child-decoration child-star star-two"
                      >
                        ★
                      </div>


                      <div
                        v-if="whatsappTheme === 'child'"
                        class="child-decoration child-balloon balloon-one"
                      >
                        ●
                      </div>

                      <div
                        v-if="whatsappTheme === 'child'"
                        class="child-decoration child-balloon balloon-two"
                      >
                        ●
                      </div>


                      <!-- CHRISTMAS DECORATIONS -->

                      <div
                        v-if="whatsappTheme === 'christmas'"
                        class="christmas-decoration snow-one"
                      >
                        ❄
                      </div>

                      <div
                        v-if="whatsappTheme === 'christmas'"
                        class="christmas-decoration snow-two"
                      >
                        ❄
                      </div>

                    </header>


                    <!-- =================================================
                         BODY
                         IMPORTANTE:
                         ESTA PARTE ES BLANCA
                         PARA FUNDIR CON EL FONDO BLANCO
                         DE LAS FOTOS DE PRODUCTOS.
                    ================================================== -->

                    <main class="status-body-section">

                      <div class="status-image-wrapper">

                        <img
                          class="status-product-image"
                          :src="
                            whatsappPreviewProduct
                              .product_color_image[0]
                              .image
                          "
                        >

                      </div>

                    </main>


                    <!-- =================================================
                         FOOTER
                    ================================================== -->

                    <footer class="status-footer-section">

                      <!-- CHRISTMAS TREE -->

                      <div
                        v-if="whatsappTheme === 'christmas'"
                        class="christmas-tree"
                      >

                        <div class="tree-star">
                          ★
                        </div>

                        <div class="tree-level tree-level-1"></div>

                        <div class="tree-level tree-level-2"></div>

                        <div class="tree-level tree-level-3"></div>

                        <div class="tree-trunk"></div>

                      </div>


                      <!-- SNOW -->

                      <div
                        v-if="whatsappTheme === 'christmas'"
                        class="christmas-decoration snow-three"
                      >
                        ❄
                      </div>

                      <div
                        v-if="whatsappTheme === 'christmas'"
                        class="christmas-decoration snow-four"
                      >
                        ❄
                      </div>


                      <!-- PRODUCT NAME -->

                      <div class="status-name">

                        {{ whatsappPreviewProduct.product.name }}

                      </div>


                      <!-- CATEGORY -->

                      <div
                        v-if="
                          whatsappShowGroup &&
                          whatsappPreviewProduct.product.group
                        "
                        class="status-product-group"
                      >

                        {{ whatsappPreviewProduct.product.group }}

                      </div>


                      <!-- DISCOUNT -->

                      <div
                        v-if="
                          whatsappPreviewProduct.product.off &&
                          whatsappShowDiscount
                        "
                        class="status-discount"
                      >

                        -{{ whatsappPreviewProduct.product.off }}% OFF

                      </div>


                      <!-- SALE PRICE -->

                      <div
                        v-if="whatsappPreviewProduct.product.off"
                        class="status-price"
                      >

                        <span class="status-currency">
                          S/
                        </span>

                        {{ whatsappPreviewProduct.product.sale_price }}

                      </div>


                      <!-- REGULAR PRICE -->

                      <div
                        v-if="
                          whatsappPreviewProduct.product.off &&
                          whatsappShowRegularPrice
                        "
                        class="status-regular-price"
                      >

                        Antes:

                        <span>
                          S/
                          {{ whatsappPreviewProduct.product.regular_price }}
                        </span>

                      </div>


                      <!-- NORMAL PRICE -->

                      <div
                        v-if="!whatsappPreviewProduct.product.off"
                        class="status-price"
                      >

                        <span class="status-currency">
                          S/
                        </span>

                        {{ whatsappPreviewProduct.product.regular_price }}

                      </div>


                      <!-- CTA -->

                      <div class="status-cta">

                        <span v-if="whatsappTemplate === 'offer'">
                          COMPRA AHORA
                        </span>

                        <span v-if="whatsappTemplate === 'new'">
                          DESCÚBRELO AHORA
                        </span>

                        <span v-if="whatsappTemplate === 'category'">
                          DESCUBRE LA COLECCIÓN
                        </span>

                      </div>


                      <!-- FOOTER BRAND -->

                      <div class="status-footer-brand">

                        <img
                          v-if="whatsappShowLogo"
                          class="status-logo"
                          :src="require('@/assets/logo.png')"
                          alt="Dino Toys"
                        >

                        <div class="status-footer-text">
                          {{ whatsappFooter }}
                        </div>

                      </div>

                    </footer>

                  </div>

                </div>


                <!-- PREVIEW INFO -->

                <div
                  class="text-center mt-3 grey--text text--darken-1"
                >

                  Vista previa:

                  <strong>
                    360 × 640
                  </strong>

                  <span class="mx-2">
                    →
                  </span>

                  Archivo final:

                  <strong>
                    1080 × 1920
                  </strong>

                </div>

              </v-col>

            </v-row>

          </v-card-text>


          <!-- =====================================================
               DIALOG FOOTER
          ====================================================== -->

          <v-card-actions class="pa-4">

            <v-btn
              text
              @click="showWhatsappGenerator = false"
              :disabled="generatingWhatsapp"
            >

              Cancelar

            </v-btn>

            <v-spacer></v-spacer>

            <v-btn
              color="green"
              dark
              large
              :loading="generatingWhatsapp"
              @click="generateWhatsappStates"
            >

              <v-icon left>
                mdi-whatsapp
              </v-icon>

              Generar Estados

            </v-btn>

          </v-card-actions>

        </v-card>

      </v-dialog>

    </section>
  </default-layout>
</template>


<script>

import DefaultLayout from '@/layouts/DefaultLayout'
import axios from 'axios'
import html2canvas from 'html2canvas'

axios.defaults.baseURL = process.env.DINO.ENDPOINT

export default {

  name: 'ProductsImage',

  components: {
    DefaultLayout
  },


  data () {

    return {

      /* =========================================================
         GENERAL
      ========================================================== */

      overlay: false,

      overlayText: '',

      disabledSubmit: true,


      /* =========================================================
         PRODUCTS
      ========================================================== */

      groupSelected: null,

      productColors: [],

      page: 1,

      length: null,

      count: 10,

      orderBy: null,


      /* =========================================================
         SELECTS
      ========================================================== */

      select: {

        groups: [

          { id: 'HOT WHEELS', name: 'HOT WHEELS' },
          { id: 'JURASSIC WORLD', name: 'JURASSIC WORLD' },
          { id: 'MINECRAFT', name: 'MINECRAFT' },
          { id: 'THOMAS & FRIENDS', name: 'THOMAS & FRIENDS' },
          { id: 'ANGRY BIRDS', name: 'ANGRY BIRDS' },
          { id: 'CHOMP SQUAD', name: 'CHOMP SQUAD' },
          { id: 'BLAZE', name: 'BLAZE' },
          { id: 'SMASHERS', name: 'SMASHERS' },
          { id: 'MUÑECAS', name: 'MUÑECAS' },
          { id: 'NINTENDO SWITCH', name: 'NINTENDO SWITCH' },
          { id: 'NERF', name: 'NERF' },
          { id: 'PLAY DOH', name: 'PLAY DOH' },
          { id: 'SUPER MARIO', name: 'SUPER MARIO' },
          { id: 'PRINCESAS', name: 'PRINCESAS' },
          { id: 'FRIEND', name: 'FRIEND' },
          { id: 'DIDACTICOS', name: 'DIDACTICOS' },

          {
            id: 'MOCHILAS, CARTUCHERAS Y LONCHERAS',
            name: 'MOCHILAS, CARTUCHERAS Y LONCHERAS'
          },

          { id: 'ÚTILES', name: 'ÚTILES' },
          { id: 'MAQUILLAJE', name: 'MAQUILLAJE' },
          { id: 'MENAJES', name: 'MENAJES' },

          {
            id: 'MAMALONCHERITA',
            name: 'MAMÁ LONCHERITA'
          },

          { id: 'BELLEZA', name: 'BELLEZA' },
          { id: 'ELECTROHOGAR', name: 'ELECTROHOGAR' },

          {
            id: 'DEVUELTAALCOLE',
            name: 'DE VUELTA AL COLE'
          },

          {
            id: 'PELUCHESINTERACTIVOS',
            name: 'PELUCHES INTERACTIVOS'
          },

          { id: 'DINO', name: 'DINO' },
          { id: 'PAWPATROL', name: 'PAW PATROL' },
          { id: 'BLUEY', name: 'BLUEY' },
          { id: 'SUPERMARIO', name: 'SUPER MARIO' },
          { id: 'JUGUETES', name: 'JUGUETES' },

          {
            id: 'JUEGOSFAMILIARES',
            name: 'JUEGOS FAMILIARES'
          },

          { id: 'BLOQUES', name: 'BLOQUES' },
          { id: 'MUNDOBEBE', name: 'MUNDO BEBE' },
          { id: 'NAVIDAD', name: 'NAVIDAD' }

        ],


        filters: [

          {
            id: 'OrderByPriceASC',
            name: 'Precio más bajo'
          },

          {
            id: 'OrderByPriceDESC',
            name: 'Precio más alto'
          },

          {
            id: 'OrderByReleaseDateDESC',
            name: 'Lo más nuevo'
          },

          {
            id: 'OrderByBestDiscountDESC',
            name: 'Mejor descuento'
          }

        ]

      },


      /* =========================================================
         NORMAL IMAGE GENERATOR
      ========================================================== */

      displayProductOff: false,
      displayChecksForWhatsapp: false,


      /* =========================================================
         WHATSAPP SELECTION
      ========================================================== */

      selectedWhatsappIds: [],


      /* =========================================================
         WHATSAPP DIALOG
      ========================================================== */

      showWhatsappGenerator: false,


      /* =========================================================
         TIPO DE ESTADO
      ========================================================== */

      whatsappTemplate: 'offer',

      whatsappTemplates: [

        {
          id: 'offer',
          name: '🔥 Oferta'
        },

        {
          id: 'new',
          name: '✨ Nuevo ingreso'
        },

        {
          id: 'category',
          name: '🧸 Colección'
        }

      ],


      /* =========================================================
         TEMA / FONDO
      ========================================================== */

      whatsappTheme: 'default',

      whatsappThemes: [

        {
          id: 'default',
          name: '🎨 Default',
          description: 'Diseño comercial limpio'
        },

        {
          id: 'child',
          name: '🧒 Día del Niño',
          description: 'Diseño colorido y divertido'
        },

        {
          id: 'christmas',
          name: '🎄 Navidad',
          description: 'Diseño navideño'
        }

      ],


      /* =========================================================
         PREVIEW
      ========================================================== */

      whatsappPreviewProductId: null,


      /* =========================================================
         TEXTOS
      ========================================================== */

      whatsappHeadline: '🔥 OFERTA',

      whatsappSubtitle: 'PRODUCTOS SELECCIONADOS',

      whatsappFooter:
        'COMPRA ONLINE EN DINOTOYS',


      /* =========================================================
         OPTIONS
      ========================================================== */

      whatsappShowDiscount: true,

      whatsappShowRegularPrice: true,

      whatsappShowLogo: true,

      whatsappShowGroup: true,


      /* =========================================================
         GENERATING
      ========================================================== */

      generatingWhatsapp: false,


      /* =========================================================
         SNACKBAR
      ========================================================== */

      snackbar: false,

      text: '',

      color: 'green'

    }

  },


  /* ===========================================================
     COMPUTED
  ============================================================ */

  computed: {

    shownCards () {

      const {
        page,
        count,
        productColors
      } = this

      return productColors.slice(
        (page - 1) * count,
        page * count
      )

    },


    selectedWhatsappProducts () {

      return this.productColors.filter(
        item =>
          this.selectedWhatsappIds.includes(item.id)
      )

    },


    whatsappPreviewProduct () {

      if (
        !this.selectedWhatsappProducts.length
      ) {

        return null

      }

      const selected =
        this.selectedWhatsappProducts.find(
          item =>
            item.id ===
            this.whatsappPreviewProductId
        )

      return (
        selected ||
        this.selectedWhatsappProducts[0]
      )

    },


    whatsappTemplateClass () {

      if (
        this.whatsappTemplate === 'new'
      ) {

        return 'template-new'

      }

      if (
        this.whatsappTemplate === 'category'
      ) {

        return 'template-category'

      }

      return 'template-offer'

    },


    whatsappThemeClass () {

      if (
        this.whatsappTheme === 'child'
      ) {

        return 'theme-child'

      }

      if (
        this.whatsappTheme === 'christmas'
      ) {

        return 'theme-christmas'

      }

      return 'theme-default'

    },


    currentStyleName () {

      const template =
        this.whatsappTemplates.find(
          item =>
            item.id === this.whatsappTemplate
        )

      const theme =
        this.whatsappThemes.find(
          item =>
            item.id === this.whatsappTheme
        )

      if (!template || !theme) {

        return 'Estilo actual'

      }

      return (
        template.name +
        ' · ' +
        theme.name
      )

    }

  },


  /* ===========================================================
     WATCH
  ============================================================ */

  watch: {

    '$route.query.q' (val) {

      if (val) {

        this.findProduct()

      }

    },


    groupSelected (val) {

      if (val) {

        this.findProduct()

      }

    },


    showWhatsappGenerator (value) {

      if (!value) {

        return

      }

      if (
        this.selectedWhatsappProducts.length
      ) {

        this.whatsappPreviewProductId =
          this.selectedWhatsappProducts[0].id

      }

    }

  },


  /* ===========================================================
     METHODS
  ============================================================ */

  methods: {

    /* =========================================================
       MESSAGE
    ========================================================== */

    showMessage (
      text,
      color
    ) {

      this.snackbar = true

      this.text = text

      this.color = color

    },


    /* =========================================================
       FIND PRODUCTS
    ========================================================== */

    findProduct () {

      const filter =
        this.$route.query.q
          ? this.$route.query.q
          : this.groupSelected

      let url =
        process.env.DINO.PATH.GET_PRODUCTS_SEARCH +
        filter +
        (
          this.orderBy
            ? '&orderBy=' + this.orderBy
            : ''
        )

      axios
        .get(url)
        .then(response => {

          this.page = 1

          this.productColors =
            response.data

          this.length =
            Math.ceil(
              response.data.length /
              this.count
            )

          this.disabledSubmit =
            response.data.length === 0

        })
        .catch(err => {

          console.error(
            'Error buscando productos:',
            err
          )

          this.showMessage(
            'No se pudieron cargar los productos.',
            'error'
          )

        })

    },


    /* =========================================================
       GENERATE NORMAL IMAGES
    ========================================================== */

    async generateImages () {

      this.disabledSubmit = true

      this.showMessage(
        'Generando imágenes, esperar por favor...',
        'green'
      )

      try {

        for (
          let index = 0;
          index < this.shownCards.length;
          index++
        ) {

          const value =
            this.shownCards[index]

          const element =
            this.$refs[value.id][0]

          const canvas =
            await html2canvas(
              element,
              {

                scale: 5,

                allowTaint: false,

                useCORS: true,

                proxy:
                  'https://firebasestorage.googleapis.com/v0/b/dino-toys.appspot.com'

              }
            )

          const link =
            document.createElement('a')

          link.download =
            this.sanitizeFileName(
              value.product.name
            ) +
            '.jpg'

          link.href =
            canvas.toDataURL(
              'image/jpeg',
              0.95
            )

          link.click()

          await this.sleep(300)

        }

        this.showMessage(
          'Imágenes generadas correctamente.',
          'green'
        )

      }
      catch (error) {

        console.error(
          'Error generando imágenes:',
          error
        )

        this.showMessage(
          'Ocurrió un error generando las imágenes.',
          'error'
        )

      }
      finally {

        this.disabledSubmit = false

      }

    },


    /* =========================================================
       SELECT ALL
    ========================================================== */

    selectAllWhatsapp () {

      this.selectedWhatsappIds =
        this.productColors.map(
          item => item.id
        )

      this.showMessage(
        this.selectedWhatsappIds.length +
        ' productos seleccionados.',
        'green'
      )

    },


    /* =========================================================
       CLEAR
    ========================================================== */

    clearWhatsappSelection () {

      this.selectedWhatsappIds = []

    },


    /* =========================================================
       OPEN GENERATOR
    ========================================================== */

    openWhatsappGenerator () {

      if (
        !this.selectedWhatsappIds.length
      ) {

        this.showMessage(
          'Seleccione al menos un producto.',
          'warning'
        )

        return

      }

      this.whatsappPreviewProductId =
        this.selectedWhatsappProducts[0].id

      this.showWhatsappGenerator = true

    },


    /* =========================================================
       CHANGE TEMPLATE
    ========================================================== */

    changeWhatsappTemplate (
      value
    ) {

      if (value === 'offer') {

        this.whatsappHeadline =
          '🔥 OFERTA'

        this.whatsappSubtitle =
          'PRODUCTOS SELECCIONADOS'

      }

      if (value === 'new') {

        this.whatsappHeadline =
          '✨ NUEVO INGRESO'

        this.whatsappSubtitle =
          'ACABA DE LLEGAR'

      }

      if (value === 'category') {

        this.whatsappHeadline =
          '🧸 DESCUBRE NUESTRA COLECCIÓN'

        this.whatsappSubtitle =
          'ENCUENTRA TU FAVORITO'

      }

    },


    /* =========================================================
       CHANGE THEME
    ========================================================== */

    changeWhatsappTheme (
      value
    ) {

      if (value === 'default') {

        if (this.whatsappTemplate === 'offer') {

          this.whatsappHeadline =
            '🔥 OFERTA'

          this.whatsappSubtitle =
            'PRODUCTOS SELECCIONADOS'

        }

        if (this.whatsappTemplate === 'new') {

          this.whatsappHeadline =
            '✨ NUEVO INGRESO'

          this.whatsappSubtitle =
            'ACABA DE LLEGAR'

        }

        if (this.whatsappTemplate === 'category') {

          this.whatsappHeadline =
            '🧸 DESCUBRE NUESTRA COLECCIÓN'

          this.whatsappSubtitle =
            'ENCUENTRA TU FAVORITO'

        }

      }


      if (value === 'child') {

        if (this.whatsappTemplate === 'offer') {

          this.whatsappHeadline =
            '🎉 OFERTAS PARA LOS PEQUES'

          this.whatsappSubtitle =
            'DIVERSIÓN A LO GRANDE'

        }

        if (this.whatsappTemplate === 'new') {

          this.whatsappHeadline =
            '🌈 NUEVOS JUGUETES'

          this.whatsappSubtitle =
            '¡MIRA LO QUE LLEGÓ!'

        }

        if (this.whatsappTemplate === 'category') {

          this.whatsappHeadline =
            '🎈 DIVERSIÓN PARA TODOS'

          this.whatsappSubtitle =
            'DESCUBRE NUESTRA COLECCIÓN'

        }

      }


      if (value === 'christmas') {

        if (this.whatsappTemplate === 'offer') {

          this.whatsappHeadline =
            '🎄 OFERTAS NAVIDEÑAS'

          this.whatsappSubtitle =
            'REGALA SONRISAS ESTA NAVIDAD'

        }

        if (this.whatsappTemplate === 'new') {

          this.whatsappHeadline =
            '🎁 NUEVO INGRESO'

          this.whatsappSubtitle =
            'REGALOS QUE TE ENCANTARÁN'

        }

        if (this.whatsappTemplate === 'category') {

          this.whatsappHeadline =
            '🎄 COLECCIÓN NAVIDEÑA'

          this.whatsappSubtitle =
            'ENCUENTRA EL REGALO PERFECTO'

        }

      }

    },


    /* =========================================================
       GENERATE WHATSAPP
    ========================================================== */

    async generateWhatsappStates () {

      if (
        !this.selectedWhatsappProducts.length
      ) {

        this.showMessage(
          'Seleccione al menos un producto.',
          'warning'
        )

        return

      }

      this.generatingWhatsapp = true

      this.overlay = true

      this.overlayText =
        'Preparando Estados WhatsApp...'

      try {

        for (
          let index = 0;
          index <
          this.selectedWhatsappProducts.length;
          index++
        ) {

          const product =
            this.selectedWhatsappProducts[index]

          this.whatsappPreviewProductId =
            product.id

          this.overlayText =
            'Generando Estado ' +
            (index + 1) +
            ' de ' +
            this.selectedWhatsappProducts.length

          await this.$nextTick()

          await this.waitForImages(
            this.$refs.whatsappStatusPreview
          )

          const canvas =
            await html2canvas(
              this.$refs.whatsappStatusPreview,
              {

                scale: 3,

                width: 360,

                height: 640,

                useCORS: true,

                allowTaint: false,

                /*
                 * El estado completo ya tiene
                 * su propio fondo.
                 */
                backgroundColor: '#ffffff',

                logging: false

              }
            )

          const link =
            document.createElement('a')

          link.download =
            'WHATSAPP_' +
            this.sanitizeFileName(
              product.product.name
            ) +
            '_' +
            this.whatsappTemplate +
            '_' +
            this.whatsappTheme +
            '.png'

          link.href =
            canvas.toDataURL(
              'image/png'
            )

          document.body.appendChild(
            link
          )

          link.click()

          document.body.removeChild(
            link
          )

          await this.sleep(500)

        }

        this.showMessage(
          'Se generaron ' +
          this.selectedWhatsappProducts.length +
          ' Estados WhatsApp correctamente.',
          'green'
        )

      }
      catch (error) {

        console.error(
          'Error generando Estados WhatsApp:',
          error
        )

        this.showMessage(
          'Ocurrió un error generando los Estados WhatsApp.',
          'error'
        )

      }
      finally {

        this.generatingWhatsapp = false

        this.overlay = false

        this.overlayText = ''

      }

    },


    /* =========================================================
       WAIT IMAGES
    ========================================================== */

    waitForImages (
      container
    ) {

      return new Promise(
        resolve => {

          if (!container) {

            resolve()

            return

          }

          const images =
            container.querySelectorAll(
              'img'
            )

          if (!images.length) {

            resolve()

            return

          }

          let loaded = 0

          const check =
            () => {

              loaded++

              if (
                loaded >= images.length
              ) {

                resolve()

              }

            }

          images.forEach(
            image => {

              if (image.complete) {

                check()

              }
              else {

                image.onload = check

                image.onerror = check

              }

            }
          )

        }
      )

    },


    /* =========================================================
       SLEEP
    ========================================================== */

    sleep (
      milliseconds
    ) {

      return new Promise(
        resolve =>
          setTimeout(
            resolve,
            milliseconds
          )
      )

    },


    /* =========================================================
       SANITIZE
    ========================================================== */

    sanitizeFileName (
      name
    ) {

      return String(
        name || 'producto'
      )
        .normalize('NFD')
        .replace(
          /[\u0300-\u036f]/g,
          ''
        )
        .replace(
          /[^a-zA-Z0-9-_ ]/g,
          ''
        )
        .replace(
          /\s+/g,
          '_'
        )
        .substring(
          0,
          100
        )

    },


    /* =========================================================
       PRODUCT IMAGE SELECTED
    ========================================================== */

    productImageSelected (
      item
    ) {

      console.log(
        'Producto seleccionado:',
        item
      )

    }

  },


  /* ===========================================================
     MOUNTED
  ============================================================ */

  mounted () {

    axios.defaults.headers = {

      authorization:
        localStorage.getItem(
          'authorization'
        )

    }

  }

}

</script>


<style scoped>

/* =============================================================
   PRODUCT CARD
============================================================= */

.product-card {

  border: 5px solid #1b74e4 !important;

  border-radius: 4px !important;

  height: 100%;

}


.product-image {

  width: 100%;

  height: 190px;

  object-fit: contain;

  background: white;

}


.whatsapp-checkbox-label {

  font-size: 12px;

  font-weight: 600;

  color: #555;

}


.product-name {

  width: 100%;

  height: 45px;

  color: black;

  overflow: hidden;

  text-overflow: ellipsis;

}


.input-group-product {

  font-size: 14px;

  color: #777;

  text-transform: uppercase;

}


.input-name-product {

  font-size: 14px;

  text-transform: uppercase;

  cursor: pointer;

}


.conetnido {

  font-size: 90%;

}


@media only screen and (min-width: 600px) {

  .conetnido {
    font-size: 94%;
  }

}


@media only screen and (min-width: 1000px) {

  .conetnido {
    font-size: 98%;
  }

}


@media only screen and (min-width: 1200px) {

  .conetnido {
    font-size: 100%;
  }

}


/* =============================================================
   GENERATOR
============================================================= */

.generator-dialog {

  overflow: hidden;

}


.generator-toolbar {

  background: #25D366 !important;

}


.generator-content {

  background: #f4f5f6;

}


.generator-section-title {

  font-size: 20px;

  font-weight: 700;

  color: #222;

  margin-bottom: 18px;

}


.configuration-label {

  font-size: 13px;

  font-weight: 700;

  color: #555;

  margin-bottom: 6px;

}


/* =============================================================
   SELECTED STYLE PREVIEW
============================================================= */

.selected-style-preview {

  height: 75px;

  width: 100%;

  border-radius: 12px;

  position: relative;

  overflow: hidden;

  margin-top: 5px;

  box-shadow:
    0 5px 15px rgba(0,0,0,.12);

}


.selected-style-overlay {

  position: absolute;

  inset: 0;

  background:
    linear-gradient(
      135deg,
      rgba(0,0,0,.15),
      rgba(0,0,0,.02)
    );

}


.selected-style-content {

  position: relative;

  z-index: 2;

  width: 100%;

  height: 100%;

  display: flex;

  align-items: center;

  justify-content: center;

  gap: 10px;

  color: white;

  font-size: 14px;

  font-weight: 800;

  text-shadow:
    0 2px 5px rgba(0,0,0,.4);

}


/* =============================================================
   PREVIEW AREA
============================================================= */

.preview-area {

  min-height: 700px;

  display: flex;

  justify-content: center;

  align-items: center;

  padding: 30px;

  border-radius: 12px;

  background:
    linear-gradient(
      135deg,
      #eeeeee 0%,
      #e5e5e5 100%
    );

}


/* =============================================================
   WHATSAPP STATUS
============================================================= */

.whatsapp-status {

  width: 360px;

  height: 640px;

  position: relative;

  overflow: hidden;

  box-sizing: border-box;

  display: flex;

  flex-direction: column;

  font-family:
    Arial,
    Helvetica,
    sans-serif;

  color: #111;

  box-shadow:
    0 20px 50px
    rgba(0,0,0,.28);

}


/* =============================================================
   HEADER
============================================================= */

.status-header-section {

  position: relative;

  width: 100%;

  height: 135px;

  min-height: 135px;

  flex-shrink: 0;

  box-sizing: border-box;

  padding:
    17px
    20px
    12px
    20px;

  display: flex;

  flex-direction: column;

  align-items: center;

  justify-content: flex-start;

  overflow: hidden;

  z-index: 10;

}


/* =============================================================
   BODY
============================================================= */

/*
 * ESTA ES LA CLAVE DEL DISEÑO.
 *
 * El body es completamente blanco.
 *
 * Como las fotografías de tus productos tienen fondo blanco,
 * el rectángulo blanco de la fotografía desaparece visualmente.
 */

.status-body-section {

  width: 100%;

  height: 300px;

  min-height: 300px;

  flex-shrink: 0;

  background: #ffffff;

  position: relative;

  z-index: 3;

  overflow: hidden;

}


/* =============================================================
   PRODUCT IMAGE
============================================================= */

.status-image-wrapper {

  width: 100%;

  height: 100%;

  display: flex;

  justify-content: center;

  align-items: center;

  background: #ffffff;

  position: relative;

}


/*
 * No ponemos glow blanco.
 *
 * El propio body ya es blanco.
 */

.status-product-image {

  width: 100%;

  height: 100%;

  max-width: 100%;

  max-height: 100%;

  object-fit: contain;

  display: block;

  position: relative;

  z-index: 2;

  filter: none;

  /*filter:
    drop-shadow(
      0 10px 8px
      rgba(0,0,0,.12)
    );*/

}


/* =============================================================
   FOOTER
============================================================= */

.status-footer-section {

  position: relative;

  width: 100%;

  flex: 1;

  min-height: 205px;

  box-sizing: border-box;

  padding:
    12px
    20px
    12px
    20px;

  display: flex;

  flex-direction: column;

  align-items: center;

  justify-content: flex-start;

  text-align: center;

  overflow: hidden;

  z-index: 5;

}


/* =============================================================
   TOP BADGE
============================================================= */

.status-top-badge {

  position: relative;

  z-index: 20;

  padding:
    5px
    16px;

  border-radius: 30px;

  color: white;

  font-size: 10px;

  font-weight: 900;

  letter-spacing: 1px;

  margin-bottom: 6px;

  box-shadow:
    0 4px 10px
    rgba(0,0,0,.15);

}


/* =============================================================
   HEADER TEXT
============================================================= */

.status-header {

  width: 100%;

  text-align: center;

  font-size: 23px;

  line-height: 26px;

  font-weight: 900;

  margin-top: 2px;

  text-transform: uppercase;

  position: relative;

  z-index: 20;

}


.status-subtitle {

  margin-top: 4px;

  font-size: 10px;

  line-height: 13px;

  font-weight: 800;

  text-align: center;

  text-transform: uppercase;

  position: relative;

  z-index: 20;

}


/* =============================================================
   PRODUCT NAME
============================================================= */

.status-name {

  width: 100%;

  min-height: 32px;

  max-height: 42px;

  text-align: center;

  font-size: 14px;

  line-height: 17px;

  font-weight: 900;

  text-transform: uppercase;

  overflow: hidden;

  position: relative;

  z-index: 20;

  color: #111;

}


/* =============================================================
   PRODUCT GROUP
============================================================= */

.status-product-group {

  margin-top: 2px;

  font-size: 9px;

  line-height: 11px;

  font-weight: 800;

  text-transform: uppercase;

  opacity: .72;

  position: relative;

  z-index: 20;

}


/* =============================================================
   DISCOUNT
============================================================= */

.status-discount {

  font-size: 12px;

  line-height: 14px;

  font-weight: 900;

  padding:
    4px
    14px;

  border-radius: 30px;

  margin-top: 4px;

  color: white;

  position: relative;

  z-index: 20;

  box-shadow:
    0 5px 12px
    rgba(0,0,0,.15);

}


/* =============================================================
   PRICE
============================================================= */

.status-price {

  margin-top: 2px;

  font-size: 34px;

  line-height: 36px;

  font-weight: 900;

  position: relative;

  z-index: 20;

  color: #111;

}


.status-currency {

  font-size: 19px;

  vertical-align: top;

}


/* =============================================================
   REGULAR PRICE
============================================================= */

.status-regular-price {

  font-size: 11px;

  line-height: 13px;

  margin-top: -1px;

  position: relative;

  z-index: 20;

  color: #444;

}


.status-regular-price span {

  text-decoration: line-through;

}


/* =============================================================
   CTA
============================================================= */

.status-cta {

  margin-top: 5px;

  padding:
    6px
    20px;

  color: white;

  font-size: 10px;

  line-height: 12px;

  font-weight: 900;

  border-radius: 30px;

  letter-spacing: .5px;

  position: relative;

  z-index: 20;

  box-shadow:
    0 5px 12px
    rgba(0,0,0,.18);

}


/* =============================================================
   BRAND FOOTER
============================================================= */

.status-footer-brand {

  margin-top: auto;

  width: 100%;

  display: flex;

  flex-direction: column;

  align-items: center;

  justify-content: center;

  text-align: center;

  font-size: 8px;

  line-height: 10px;

  font-weight: 900;

  position: relative;

  z-index: 20;

}


.status-logo {

  width: 40px;

  max-height: 40px;

  object-fit: contain;

  margin-bottom: 2px;

}


.status-footer-text {

  text-transform: uppercase;

}


/* =============================================================
   BACKGROUND SHAPES
   IMPORTANTE:
   ahora quedan detrás de header/footer.
   El BODY BLANCO permanece completamente limpio.
============================================================= */

.status-background-shape {

  position: absolute;

  border-radius: 50%;

  pointer-events: none;

  z-index: 1;

}


.shape-one {

  width: 210px;

  height: 210px;

  top: -130px;

  right: -90px;

}


.shape-two {

  width: 180px;

  height: 180px;

  bottom: -90px;

  left: -90px;

}


.shape-three {

  width: 100px;

  height: 100px;

  top: 70px;

  left: -60px;

}


/* =============================================================
   TEMPLATE: OFERTA
============================================================= */

.template-offer {

  background:
    linear-gradient(
      160deg,
      #fff7ed 0%,
      #ffffff 45%,
      #fff0f0 100%
    );

}


.template-offer .status-header-section {

  background:
    linear-gradient(
      160deg,
      #fff7ed 0%,
      #ffffff 100%
    );

}


.template-offer .status-footer-section {

  background:
    linear-gradient(
      160deg,
      #ffffff 0%,
      #fff0f0 100%
    );

}


.template-offer .shape-one {

  background:
    rgba(255,87,34,.15);

}


.template-offer .shape-two {

  background:
    rgba(233,30,99,.10);

}


.template-offer .shape-three {

  background:
    rgba(255,193,7,.10);

}


.template-offer .status-header {

  color: #e53935;

}


.template-offer .status-top-badge {

  background:
    linear-gradient(
      135deg,
      #ff1744,
      #e53935
    );

}


.template-offer .status-discount {

  background:
    linear-gradient(
      135deg,
      #e91e63,
      #c2185b
    );

}


.template-offer .status-cta {

  background:
    linear-gradient(
      135deg,
      #e53935,
      #c62828
    );

}


.template-offer .status-price {

  color: #c62828;

}


/* =============================================================
   TEMPLATE: NUEVO
============================================================= */

.template-new {

  background:
    linear-gradient(
      160deg,
      #edfff3 0%,
      #ffffff 45%,
      #e8f5e9 100%
    );

}


.template-new .status-header-section {

  background:
    linear-gradient(
      160deg,
      #edfff3 0%,
      #ffffff 100%
    );

}


.template-new .status-footer-section {

  background:
    linear-gradient(
      160deg,
      #ffffff 0%,
      #e8f5e9 100%
    );

}


.template-new .shape-one {

  background:
    rgba(76,175,80,.14);

}


.template-new .shape-two {

  background:
    rgba(0,188,212,.10);

}


.template-new .shape-three {

  background:
    rgba(139,195,74,.12);

}


.template-new .status-header {

  color: #2e7d32;

}


.template-new .status-top-badge {

  background:
    linear-gradient(
      135deg,
      #43a047,
      #1b5e20
    );

}


.template-new .status-discount {

  background:
    linear-gradient(
      135deg,
      #43a047,
      #2e7d32
    );

}


.template-new .status-cta {

  background:
    linear-gradient(
      135deg,
      #43a047,
      #1b5e20
    );

}


.template-new .status-price {

  color: #2e7d32;

}


/* =============================================================
   TEMPLATE: COLECCIÓN
============================================================= */

.template-category {

  background:
    linear-gradient(
      160deg,
      #f7f1ff 0%,
      #ffffff 45%,
      #eee7ff 100%
    );

}


.template-category .status-header-section {

  background:
    linear-gradient(
      160deg,
      #f7f1ff 0%,
      #ffffff 100%
    );

}


.template-category .status-footer-section {

  background:
    linear-gradient(
      160deg,
      #ffffff 0%,
      #eee7ff 100%
    );

}


.template-category .shape-one {

  background:
    rgba(103,58,183,.15);

}


.template-category .shape-two {

  background:
    rgba(156,39,176,.10);

}


.template-category .shape-three {

  background:
    rgba(63,81,181,.10);

}


.template-category .status-header {

  color: #673ab7;

}


.template-category .status-top-badge {

  background:
    linear-gradient(
      135deg,
      #7e57c2,
      #4527a0
    );

}


.template-category .status-discount {

  background:
    linear-gradient(
      135deg,
      #7e57c2,
      #512da8
    );

}


.template-category .status-cta {

  background:
    linear-gradient(
      135deg,
      #7e57c2,
      #4527a0
    );

}


.template-category .status-price {

  color: #512da8;

}


/* =============================================================
   THEME DEFAULT
============================================================= */

.theme-default {

  /*
   * El template controla el degradado.
   */

}


/* =============================================================
   DÍA DEL NIÑO
============================================================= */

.theme-child {

  background:
    linear-gradient(
      145deg,
      #fff9c4 0%,
      #fff 28%,
      #e1f5fe 65%,
      #fce4ec 100%
    );

}


.theme-child .status-header-section {

  background:
    linear-gradient(
      145deg,
      #fff9c4 0%,
      #ffffff 100%
    );

}


.theme-child .status-footer-section {

  background:
    linear-gradient(
      145deg,
      #ffffff 0%,
      #e1f5fe 45%,
      #fce4ec 100%
    );

}


.theme-child .status-top-badge {

  background:
    linear-gradient(
      135deg,
      #ff4081,
      #7c4dff
    );

}


.theme-child .status-header {

  color: #ff4081;

  text-shadow:
    2px 2px 0 #fff59d;

}


.theme-child .status-cta {

  background:
    linear-gradient(
      135deg,
      #ff4081,
      #7c4dff
    );

}


.theme-child .status-discount {

  background:
    linear-gradient(
      135deg,
      #ff9800,
      #ff5722
    );

}


.theme-child .status-price {

  color: #ff4081;

}


/* =============================================================
   DECORACIÓN INFANTIL
============================================================= */

.child-decoration {

  position: absolute;

  z-index: 15;

  pointer-events: none;

}


.child-star {

  font-size: 24px;

  color: #ffca28;

  text-shadow:
    0 3px 5px rgba(0,0,0,.15);

}


.star-one {

  top: 65px;

  left: 16px;

  transform:
    rotate(-15deg);

}


.star-two {

  top: 70px;

  right: 18px;

  color: #7c4dff;

  transform:
    rotate(20deg);

}


.child-balloon {

  width: 26px;

  height: 34px;

  border-radius:
    50% 50% 48% 48%;

  color: transparent;

  box-shadow:
    0 4px 8px
    rgba(0,0,0,.12);

}


.balloon-one {

  background: #ff4081;

  left: 12px;

  bottom: 115px;

}


.balloon-two {

  background: #00bcd4;

  right: 12px;

  bottom: 125px;

}


/* =============================================================
   NAVIDAD
============================================================= */

.theme-christmas {

  background:
    linear-gradient(
      145deg,
      #fff 0%,
      #fef3f3 35%,
      #e8f5e9 72%,
      #dff2ff 100%
    );

}


.theme-christmas .status-header-section {

  background:
    linear-gradient(
      145deg,
      #ffffff 0%,
      #fef3f3 100%
    );

}


.theme-christmas .status-footer-section {

  background:
    linear-gradient(
      145deg,
      #ffffff 0%,
      #e8f5e9 60%,
      #dff2ff 100%
    );

}


.theme-christmas .status-top-badge {

  background:
    linear-gradient(
      135deg,
      #c62828,
      #8e0000
    );

}


.theme-christmas .status-header {

  color: #c62828;

}


.theme-christmas .status-cta {

  background:
    linear-gradient(
      135deg,
      #c62828,
      #8e0000
    );

}


.theme-christmas .status-discount {

  background:
    linear-gradient(
      135deg,
      #d32f2f,
      #b71c1c
    );

}


.theme-christmas .status-price {

  color: #b71c1c;

}


/* =============================================================
   NIEVE
============================================================= */

.christmas-decoration {

  position: absolute;

  z-index: 15;

  color: white;

  font-size: 22px;

  text-shadow:
    0 2px 5px rgba(0,0,0,.15);

  pointer-events: none;

}


.snow-one {

  top: 62px;

  left: 18px;

}


.snow-two {

  top: 72px;

  right: 18px;

  font-size: 17px;

}


.snow-three {

  bottom: 110px;

  left: 18px;

  font-size: 18px;

}


.snow-four {

  bottom: 70px;

  right: 18px;

  font-size: 25px;

}


/* =============================================================
   ÁRBOL NAVIDEÑO
============================================================= */

.christmas-tree {

  position: absolute;

  right: -2px;

  bottom: 5px;

  width: 55px;

  height: 85px;

  z-index: 10;

  opacity: .85;

}


.tree-star {

  position: absolute;

  top: -12px;

  left: 20px;

  color: #ffd54f;

  font-size: 18px;

  z-index: 3;

}


.tree-level {

  position: absolute;

  left: 3px;

  width: 0;

  height: 0;

  border-left:
    25px solid transparent;

  border-right:
    25px solid transparent;

  border-bottom:
    38px solid #2e7d32;

}


.tree-level-1 {

  top: 5px;

}


.tree-level-2 {

  top: 25px;

  transform:
    scale(1.12);

}


.tree-level-3 {

  top: 48px;

  transform:
    scale(1.3);

}


.tree-trunk {

  position: absolute;

  bottom: 0;

  left: 22px;

  width: 11px;

  height: 20px;

  background: #795548;

}


/* =============================================================
   COMBINACIONES TEMPLATE + CHILD
============================================================= */

.template-offer.theme-child {

  background:
    radial-gradient(
      circle at 10% 15%,
      rgba(255,235,59,.45),
      transparent 25%
    ),
    radial-gradient(
      circle at 90% 30%,
      rgba(255,64,129,.20),
      transparent 28%
    ),
    linear-gradient(
      145deg,
      #fff8e1,
      #ffffff 45%,
      #fce4ec
    );

}


.template-offer.theme-child .status-header-section {

  background:
    linear-gradient(
      145deg,
      #fff8e1,
      #ffffff
    );

}


.template-offer.theme-child .status-footer-section {

  background:
    linear-gradient(
      145deg,
      #ffffff,
      #fce4ec
    );

}


.template-new.theme-child {

  background:
    radial-gradient(
      circle at 10% 15%,
      rgba(0,188,212,.25),
      transparent 25%
    ),
    radial-gradient(
      circle at 90% 30%,
      rgba(124,77,255,.20),
      transparent 28%
    ),
    linear-gradient(
      145deg,
      #e8f5e9,
      #ffffff 45%,
      #e3f2fd
    );

}


.template-new.theme-child .status-header-section {

  background:
    linear-gradient(
      145deg,
      #e8f5e9,
      #ffffff
    );

}


.template-new.theme-child .status-footer-section {

  background:
    linear-gradient(
      145deg,
      #ffffff,
      #e3f2fd
    );

}


.template-category.theme-child {

  background:
    radial-gradient(
      circle at 10% 15%,
      rgba(255,193,7,.30),
      transparent 25%
    ),
    radial-gradient(
      circle at 90% 30%,
      rgba(156,39,176,.20),
      transparent 28%
    ),
    linear-gradient(
      145deg,
      #fff3e0,
      #ffffff 45%,
      #f3e5f5
    );

}


.template-category.theme-child .status-header-section {

  background:
    linear-gradient(
      145deg,
      #fff3e0,
      #ffffff
    );

}


.template-category.theme-child .status-footer-section {

  background:
    linear-gradient(
      145deg,
      #ffffff,
      #f3e5f5
    );

}


/* =============================================================
   COMBINACIONES TEMPLATE + NAVIDAD
============================================================= */

.template-offer.theme-christmas {

  background:
    radial-gradient(
      circle at 10% 10%,
      rgba(198,40,40,.15),
      transparent 28%
    ),
    radial-gradient(
      circle at 90% 20%,
      rgba(46,125,50,.16),
      transparent 30%
    ),
    linear-gradient(
      145deg,
      #fff,
      #ffebee 45%,
      #e8f5e9
    );

}


.template-offer.theme-christmas .status-header-section {

  background:
    linear-gradient(
      145deg,
      #ffffff,
      #ffebee
    );

}


.template-offer.theme-christmas .status-footer-section {

  background:
    linear-gradient(
      145deg,
      #ffffff,
      #e8f5e9
    );

}


.template-new.theme-christmas {

  background:
    radial-gradient(
      circle at 10% 10%,
      rgba(46,125,50,.16),
      transparent 28%
    ),
    radial-gradient(
      circle at 90% 20%,
      rgba(198,40,40,.15),
      transparent 30%
    ),
    linear-gradient(
      145deg,
      #ffffff,
      #e8f5e9 45%,
      #ffebee
    );

}


.template-new.theme-christmas .status-header-section {

  background:
    linear-gradient(
      145deg,
      #ffffff,
      #e8f5e9
    );

}


.template-new.theme-christmas .status-footer-section {

  background:
    linear-gradient(
      145deg,
      #ffffff,
      #ffebee
    );

}


.template-category.theme-christmas {

  background:
    radial-gradient(
      circle at 10% 10%,
      rgba(123,31,162,.14),
      transparent 28%
    ),
    radial-gradient(
      circle at 90% 20%,
      rgba(198,40,40,.15),
      transparent 30%
    ),
    linear-gradient(
      145deg,
      #ffffff,
      #f3e5f5 45%,
      #ffebee
    );

}


.template-category.theme-christmas .status-header-section {

  background:
    linear-gradient(
      145deg,
      #ffffff,
      #f3e5f5
    );

}


.template-category.theme-christmas .status-footer-section {

  background:
    linear-gradient(
      145deg,
      #ffffff,
      #ffebee
    );

}


/* =============================================================
   MOBILE
============================================================= */

@media only screen and (max-width: 600px) {

  .preview-area {

    padding: 15px;

    min-height: 670px;

  }


  .whatsapp-status {

    transform:
      scale(.88);

    transform-origin:
      center center;

  }

}

</style>



// WEBPACK FOOTER //
// src/views/marketing/ProductsImage.vue